var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 67,
    viewBox: "0 0 100 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4452 0C81.7545 0 83.6265 1.87204 83.6265 4.18133V50.1759C83.6265 52.4852 81.7545 54.3572 79.4452 54.3572H48.5034C48.5034 57.1452 49.9906 59.9332 52.9649 62.7212L64.8106 62.7199C65.9652 62.7199 66.9012 63.6559 66.9012 64.8106C66.9012 65.9652 65.9652 66.9012 64.8106 66.9012H18.816C17.6613 66.9012 16.7253 65.9652 16.7253 64.8106C16.7253 63.6559 17.6613 62.7199 18.816 62.7199L30.6616 62.7212C33.636 59.9332 35.1231 57.1452 35.1231 54.3572H4.18133C1.87204 54.3572 0 52.4852 0 50.1759V4.18133C0 1.87204 1.87204 0 4.18133 0H79.4452ZM79.4401 4.18084H4.17625V45.9941H79.4401V4.18084Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.994 12.6918C97.8686 12.6918 99.3882 14.2114 99.3882 16.086V63.6058C99.3882 65.4804 97.8686 67 95.994 67H72.2341C70.3595 67 68.8398 65.4804 68.8398 63.6058V16.086C68.8398 14.2114 70.3595 12.6918 72.2341 12.6918H95.994Z",
    fill: "#1B0076"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9942 16.0856H72.2344V63.6053H95.9942V16.0856Z",
    fill: "#E1E6F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1205 19.4805C85.0578 19.4805 85.8176 20.2403 85.8176 21.1776C85.8176 22.1149 85.0578 22.8747 84.1205 22.8747C83.1832 22.8747 82.4233 22.1149 82.4233 21.1776C82.4233 20.2403 83.1832 19.4805 84.1205 19.4805Z",
    fill: "#E71E3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3314 56.8171H90.9085C91.8458 56.8171 92.6056 57.577 92.6056 58.5143C92.6056 59.4516 91.8458 60.2114 90.9085 60.2114H77.3314C76.3941 60.2114 75.6343 59.4516 75.6343 58.5143C75.6343 57.577 76.3941 56.8171 77.3314 56.8171Z",
    fill: "#E71E3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.5c9b349c.svg";
export { ForwardRef as ReactComponent };